/**
 * Enum for all possible values returned by the `typeof` operator in JavaScript.
 * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/typeof
 */
export enum TypeofEnum {
  UNDEFINED = "undefined",
  OBJECT = "object",
  BOOLEAN = "boolean",
  NUMBER = "number",
  BIGINT = "bigint",
  STRING = "string",
  SYMBOL = "symbol",
  FUNCTION = "function",
}
